import ElIcon from './Icon.vue'

/* istanbul ignore next */
ElIcon.install = function (app) {
  app.component(ElIcon.name, ElIcon)
}

export default ElIcon
